<head>
  <link rel="stylesheet" href="https://use.typekit.net/ahw0mno.css"></link>
  <link rel="stylesheet" href="https://use.typekit.net/ahw0mno.css"></link>
  <link href='https://api.mapbox.com/mapbox-gl-js/v1.10.1/mapbox-gl.css' rel='stylesheet' />
  <link href='https://api.tiles.mapbox.com/mapbox-gl-js/v2.9.2/mapbox-gl.css' rel='stylesheet' />
  <link rel="stylesheet" href="https://use.typekit.net/ahw0mno.css"></link>
</head>
<template>
  <div id="Map" ref="map">
    <!-- <MapBox /> -->


    <audio preload="metadata" :src="require('../assets/audio/BridgerBayBeach.mp3')" ref="audio1" @timeupdate="UpdateTime(1)" ></audio>
    <audio preload="metadata" :src="require('../assets/audio/BuffaloPoint.mp3')" ref="audio2" @timeupdate="UpdateTime(2)" ></audio>
    <audio preload="metadata" :src="require('../assets/audio/Causeway1.mp3')" ref="audio3" @timeupdate="UpdateTime(3)" ></audio>
    <audio preload="metadata" :src="require('../assets/audio/Causeway2.mp3')" ref="audio4" @timeupdate="UpdateTime(4)" ></audio>
    <audio preload="metadata" :src="require('../assets/audio/FGR.mp3')" ref="audio5" @timeupdate="UpdateTime(5)" ></audio>


    <div id="listContainer">

      <div class="itemContainer"
        :class="{ active3: isActive3 }"
        @click="activeAudio(3)">
        <div class="icon"
          :class="{activeIcon: isActive3}"></div>
        <h4>Causeway 1</h4>
      </div>

      <div class="itemContainer"
        :class="{ active4: isActive4 }"
        @click="activeAudio(4)">
        <div class="icon"
          :class="{activeIcon: isActive4}"></div>
        <h4>Causeway 2</h4>
      </div>

      <div class="itemContainer"
        :class="{ active2: isActive2 }"
        @click="activeAudio(2)">
        <div class="icon"
          :class="{activeIcon: isActive2}"></div>
        <h4>Buffalo Point</h4>
      </div>

      <div class="itemContainer"
        :class="{ active5: isActive5 }"
        @click="activeAudio(5)">
        <div class="icon"
          :class="{activeIcon: isActive5}"></div>
        <h4>Fielding Garr Ranch</h4>
      </div>

      <div class="itemContainer"
        :class="{ active1: isActive1 }"
        @click="activeAudio(1)">
        <div class="icon"
          :class="{activeIcon: isActive1}"></div>
        <h4>Bridger Bay Beach</h4>
      </div>
      
    </div>






    <v-bottom-navigation
      class="bottomStick"
      style="height: 162px; width: 100%;"
    >
      <v-flex style="display:flex; flex-direction:column; width: 100%">
        <v-flex class="control-flex">
          <v-icon>mdi-cog</v-icon>
          <v-icon v-on:click="prevTrack()">mdi-skip-previous</v-icon>
          <v-icon v-show="audioState =='pause'" v-on:click="pickAudio(chosenAudio)">mdi-play</v-icon>
          <v-icon v-show="audioState =='play'" v-on:click="pickAudio(chosenAudio)">mdi-pause</v-icon>
          <v-icon v-on:click="nextTrack()" >mdi-skip-next</v-icon>
          <v-icon
            @click="goToMap()">mdi-map-marker</v-icon>
        </v-flex>
        <div style="display:flex; justify-content: center">
          <h3 id="audioTitle">{{ audioName }}</h3>
        </div>
        <div style="display: flex; align-items: center; justify-content: center; margin: 0px 20px">
          <v-icon @click="back10()" class="otherButtons">mdi-rewind-10</v-icon>
          <!-- <audio>
            <source src={{ audioItem }}>
          </audio> -->

          <!-- <div class="currentProgressBar">
            <div class="currentProgress"></div>
          </div> -->

        
          <v-slider
            v-model="currentTime"
            :color="slider.color"
            min="0"
            :max="totalAudioTime"
            

          ></v-slider>
            

          <v-icon @click="forward10()" class="otherButtons">mdi-fast-forward-10</v-icon>
        </div>

        <div style="display: flex; justify-content: space-between; margin: 0px 52px 20px 52px;">
          <p>{{fancyCurrentTime}}</p>
          <p>{{fancyTotalAudioTime}}</p>
        </div>
        


      </v-flex>
    </v-bottom-navigation>
    
  </div>


  
</template>


<script>
    export default {
        data () {
            return {
                slideIndex: 0,
                sheet: false,
                isActive1: false,
                isActive2: false,
                isActive3: false,
                isActive4: false,
                isActive5: false,

                audioState: "pause",
                audioName: "welcome to antelope island",
                slider: { value: 10, color: 'grey'},
                currentTime: 0,
                fancyCurrentTime: "",
                totalAudioTime: 0,
                fancyTotalAudioTime: "",
                durations:["0:54", "0:29", "1:04", "0:41", "0:46"],
                chosenAudio: 1,
                //tracks: [this.$refs.audio1, this.$refs.audio2, this.$refs.audio3, this.$refs.audio4, this.$refs.audio5]
            }
        },
        created(){

        },
        methods: {
          activeAudio(x){
            this.isActive1 = false;
            this.isActive2 = false;
            this.isActive3 = false;
            this.isActive4 = false;
            this.isActive5 = false;
            if(x == 1){
              this.isActive1 = true;
              this.chosenAudio = 1;
              this.pauseAll();
              //grab audio durations
              console.log(this.$refs);
              this.$refs.audio1.currentTime = 0;
              this.totalAudioTime = this.$refs.audio1.duration;
              this.fancyTotalAudioTime = this.durations[0];
              this.audioState = "play";
              this.$refs.audio1.play();
              this.audioName = "Bridger Bay Beach";
            }
            else if(x == 2){
              this.isActive2 = true;
              this.chosenAudio = 2;
              this.pauseAll();
              //grab audio durations
              console.log(this.$refs);
              this.$refs.audio2.currentTime = 0;
              this.totalAudioTime = this.$refs.audio2.duration;
              this.fancyTotalAudioTime = this.durations[1];
              this.audioState = "play";
              this.$refs.audio2.play();
              this.audioName = "Buffalo Point";
            }
            else if(x == 3){
              this.isActive3 = true;
              this.chosenAudio = 3;
              this.pauseAll();
              //grab audio durations
              console.log(this.$refs);
              this.$refs.audio3.currentTime = 0;
              this.totalAudioTime = this.$refs.audio3.duration;
              this.fancyTotalAudioTime = this.durations[2];
              this.audioState = "play";
              this.$refs.audio3.play();
              this.audioName = "Causeway 1";
            }
            else if(x == 4){
              this.isActive4 = true;
              this.chosenAudio = 4;
              this.pauseAll();
              //grab audio durations
              console.log(this.$refs);
              this.$refs.audio4.currentTime = 0;
              this.totalAudioTime = this.$refs.audio4.duration;
              this.fancyTotalAudioTime = this.durations[3];
              this.audioState = "play";
              this.$refs.audio4.play();
              this.audioName = "Causeway 2";
            }
            else{
              this.isActive5 = true;
              this.chosenAudio = 5;
              this.pauseAll();
              //grab audio durations
              console.log(this.$refs);
              this.$refs.audio5.currentTime = 0;
              this.totalAudioTime = this.$refs.audio5.duration;
              this.fancyTotalAudioTime = this.durations[4];
              this.audioState = "play";
              this.$refs.audio5.play();
              this.audioName = "Fielding Garr Ranch";
            }
          },
          pauseAll(){
            this.$refs.audio1.pause();
            this.$refs.audio2.pause();
            this.$refs.audio3.pause();
            this.$refs.audio4.pause();
            this.$refs.audio5.pause();
          },
          UpdateTime(x){
            if(x == 1){
              this.currentTime = this.$refs.audio1.currentTime;
              //this.totalAudioTime = this.$refs.audio1.duration;
            }
            else if(x == 2){
              this.currentTime = this.$refs.audio2.currentTime;
              //this.totalAudioTime = this.$refs.audio2.duration;
            }
            else if(x == 3){
              this.currentTime = this.$refs.audio3.currentTime;
              //this.totalAudioTime = this.$refs.audio3.duration;
            }
            else if(x == 4){
              this.currentTime = this.$refs.audio4.currentTime;
              //this.totalAudioTime = this.$refs.audio4.duration;
            }
            else if(x == 5){
              this.currentTime = this.$refs.audio5.currentTime;
              //this.totalAudioTime = this.$refs.audio5.duration;
            }
            else{
              console.log("error with audio time");
            }
            this.currentTime = Math.round(this.currentTime);
            this.fancyCurrentTime = this.fancyTimeFormat(this.currentTime);
            

          },
          fancyTimeFormat: function(s) {
            return String((s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s);
          },
          pickAudio(x){
            if (x == 3){
              this.chosenAudio = 3;
              if(this.audioState == 'pause'){
                // this.audio.play();
                this.$refs.audio3.play();
                // audio.currentTime = 0;
                this.audioState = "play";
              } 
              else{
                // this.audio.pause();
                this.$refs.audio3.pause();
                this.audioState = "pause";
              }
            }
            else if (x == 1){
              this.chosenAudio = 1;
              if(this.audioState == 'pause'){
                // this.audio.play();
                this.$refs.audio1.play();
                // audio.currentTime = 0;
                this.audioState = "play";
              }
              else{
                // this.audio.pause();
                  this.$refs.audio1.pause();
                  this.audioState = "pause";
              }
            }
            else if (x == 2){
              this.chosenAudio = 2;
              if(this.audioState == 'pause'){
                // this.audio.play();
                this.$refs.audio2.play();
                // audio.currentTime = 0;
                this.audioState = "play";
              }
              else{
                // this.audio.pause();
                  this.$refs.audio2.pause();
                  this.audioState = "pause";
              }
            }
            else if (x == 4){
              this.chosenAudio = 4;
              if(this.audioState == 'pause'){
                // this.audio.play();
                this.$refs.audio4.play();
                // audio.currentTime = 0;
                this.audioState = "play";
              }
              else{
                // this.audio.pause();
                  this.$refs.audio4.pause();
                  this.audioState = "pause";
              }
            }
            else if (x == 5){
              this.chosenAudio = 5;
              if(this.audioState == 'pause'){
                // this.audio.play();
                this.$refs.audio5.play();
                // audio.currentTime = 0;
                this.audioState = "play";
              }
              else{
                // this.audio.pause();
                  this.$refs.audio5.pause();
                  this.audioState = "pause";
              }
            }
            else{
              this.chosenAudio = 3;
              if(this.audioState == 'pause'){
                // this.audio.play();
                this.$refs.audio3.play();
                // audio.currentTime = 0;
                this.audioState = "play";
              }
              else{
                // this.audio.pause();
                  this.$refs.audio3.pause();
                  this.audioState = "pause";
              }
            }
          },
          goToMap(){
            this.$router.push("/tour");
          },
          forward10(){
            if(this.chosenAudio == 1){
              this.$refs.audio1.currentTime += 10;
              this.currentTime += 10;
            }
            else if(this.chosenAudio == 2){
              this.$refs.audio2.currentTime += 10;
              this.currentTime += 10;
            }
            else if(this.chosenAudio == 3){
              this.$refs.audio3.currentTime += 10;
              this.currentTime += 10;
            }
            else if(this.chosenAudio == 4){
              this.$refs.audio4.currentTime += 10;
              this.currentTime += 10;
            }
            else if(this.chosenAudio == 5){
              this.$refs.audio5.currentTime += 10;
              this.currentTime += 10;
            }
            else{
              console.log("error with forward10");
            }
          },
          back10(){
            if(this.chosenAudio == 1){
              this.$refs.audio1.currentTime -= 10;
              this.currentTime -= 10;
            }
            else if(this.chosenAudio == 2){
              this.$refs.audio2.currentTime -= 10;
              this.currentTime -= 10;
            }
            else if(this.chosenAudio == 3){
              this.$refs.audio3.currentTime -= 10;
              this.currentTime -= 10;
            }
            else if(this.chosenAudio == 4){
              this.$refs.audio4.currentTime -= 10;
              this.currentTime -= 10;
            }
            else if(this.chosenAudio == 5){
              this.$refs.audio5.currentTime -= 10;
              this.currentTime -= 10;
            }
            else{
              console.log("error with back10");
            }
          },
          nextTrack(){
            if(this.chosenAudio == 3){
              this.chosenAudio = 4;
              // this.$refs.audio3.pause();
              // this.$refs.audio4.play();
              // this.audioState = "play";
              // this.audioName = "Causeway 2";
              this.activeAudio(4);
            }
            else if(this.chosenAudio == 4){
              this.chosenAudio = 2;
              // this.$refs.audio4.pause();
              // this.$refs.audio2.play();
              // this.audioState = "play";
              // this.audioName = "Buffalo Point";
              this.activeAudio(2);
            }
            else if(this.chosenAudio == 2){
              this.chosenAudio = 5;
              // this.$refs.audio2.pause();
              // this.$refs.audio5.play();
              // this.audioState = "play";
              // this.audioName = "Fielding Garr Ranch";
              this.activeAudio(5);
            }
            else if(this.chosenAudio == 5){
              this.chosenAudio = 1;
              // this.$refs.audio5.pause();
              // this.$refs.audio1.play();
              // this.audioState = "play";
              // this.audioName = "Bridger Bay Beach";
              this.activeAudio(1);
            }
            else if(this.chosenAudio == 1){
              this.chosenAudio = 3;
              // this.$refs.audio1.pause();
              // this.$refs.audio3.play();
              // this.audioState = "play";
              // this.audioName = "Causeway 1";
              this.activeAudio(3);
            }
            else{
              console.log("error with nextTrack");
            }
          },
          prevTrack(){
            if(this.chosenAudio == 3){
              this.chosenAudio = 1;
              // this.$refs.audio3.pause();
              // this.$refs.audio1.play();
              // this.audioState = "play";
              // this.audioName = "Bridger Bay Beach";
              this.activeAudio(1);
            }
            else if(this.chosenAudio == 1){
              this.chosenAudio = 5;
              // this.$refs.audio1.pause();
              // this.$refs.audio5.play();
              // this.audioState = "play";
              // this.audioName = "Fielding Garr Ranch";
              this.activeAudio(5);
            }
            else if(this.chosenAudio == 5){
              this.chosenAudio = 2;
              // this.$refs.audio5.pause();
              // this.$refs.audio2.play();
              // this.audioState = "play";
              // this.audioName = "Buffalo Point";
              this.activeAudio(2);
            }
            else if(this.chosenAudio == 2){
              this.chosenAudio = 4;
              // this.$refs.audio2.pause();
              // this.$refs.audio4.play();
              // this.audioState = "play";
              // this.audioName = "Causeway 2";
              this.activeAudio(4);
            }
            else if(this.chosenAudio == 4){
              this.chosenAudio = 3;
              // this.$refs.audio4.pause();
              // this.$refs.audio3.play();
              // this.audioState = "play";
              // this.audioName = "Causeway 1";
              this.activeAudio(3);
            }
            else{
              console.log("error with prevTrack");
            }
          },
        }
    }
</script>



<style>
h4{
  font-family: 'Lato';
  font-size: 16px;
  position: absolute;
  left: 70px;
}
.icon{
  background-image: url(../assets/images/pin.svg);
  width: 18px;
  height: 27px;
  margin-left: 9px;
}
.activeIcon{
  background-image: url(../assets/images/pin-headphone.svg);
  width: 36px;
  height: 31px;
  margin-left: 0px;
}
#listContainer{
  display: flex;
  display: flex;
  flex-direction: column;
}
.itemContainer{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 20px;
}
.active1{
  background-color: #EBEBEB;
}
.active2{
  background-color: #EBEBEB;
}
.active3{
  background-color: #EBEBEB;
}
.active4{
  background-color: #EBEBEB;
}
.active5{
  background-color: #EBEBEB;
}






#Map{
    /* background-image: url(../assets/images/placermap.svg); */
    background-size: cover;
    height: 100vh;
  }
  .bottomStick{
    position: fixed;
    bottom: 0;
    height: 150px;
  }
  .theme--light.v-btn.v-btn--has-bg{
    background-color: white;
  }
  .control-flex{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin: 15px 30px;
  }
  .flex{
    flex: unset;
  }
  h3{
    font-size: 14px;
    line-height: 21px;
  }
  .currentProgressBar{
    width: 75%;
    background-color: #414141;
    margin: 0.75rem;
    height: 1px;
  }
  .red{
    background-color: #5E727F !important;
  }
  .control-flex > i {
    border-width: 1px;
    border-style: solid;
    border-color: #C8C8C8;
    border-radius: 90px;
    padding: 10px;
  }
  .control-flex > button {
    border-width: 1px;
    border-style: solid;
    border-color: #C8C8C8;
    border-radius: 90px;
    padding: 10px;
    width: unset;
  }
  p{
    font-size: 14px;
    text-align: center;
  }
  .v-messages{
    display: none;
  }
  .text-center{
    background-color: aquamarine;
    width: 100%;
    height: 90vh;
  }
  #audioTitle{
    color: #414141;
    font-family: pulpo, serif;
  }
  .otherButtons{
    width: unset;
  }
  .GPSoverlay{
    z-index: 1;
    background-color: black;
  }
  .GPSoverlay > p{
    color: white;
  }
</style>
